import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row full-width" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-auto text-h5" }, "Testes", -1)
const _hoisted_3 = { class: "col-auto" }
const _hoisted_4 = { class: "row justify-center full-width q-mt-xl" }
const _hoisted_5 = { class: "col" }

import { api } from '@/utils';
import { plainToInstance } from 'class-transformer';
import { ref } from 'vue';
import { Report } from '@/models/report';
import useQuasar from 'quasar/src/composables/use-quasar.js';;


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const quasar = useQuasar();

const reports = ref<Report[]>([]);

const tableColumns = [
  {
    name: 'farmer',
    required: true,
    label: 'Nome',
    align: 'left',
    field: (row: Report): string => row.farmer,
    sortable: true,
  },
  {
    name: 'crop',
    required: true,
    label: 'Cultura',
    align: 'center',
    field: (row: Report): string => row.crop?.name || '-',
    sortable: true,
  },
  {
    name: 'createdAt',
    required: true,
    label: 'Data de criação',
    align: 'center',
    field: (row: Report): string => row.createdAt.format('L'),
    sortable: true,
  },
  {
    name: 'actions',
    label: '',
    align: 'right',
    field: (row: Report): Report => row,
    sortable: false,
  },
];

const init = () => {

  quasar.loading.show();

  api
    .get('report', { params: { relations: 'crop' } })
    .then((response) => {

      quasar.loading.hide();

      reports.value = plainToInstance(Report, response.data);
    })
    .catch((error) => {

      quasar.loading.hide();

      quasar.notify({
        type: 'negative',
        message: 'Erro ao obter lista dos testes.',
      });

      console.log('Erro ao obter lista dos testes.', error.response);
    });
};

init();

return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_q_space),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_q_btn, {
          color: "primary",
          label: "Criar Novo",
          to: "/teste"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_q_table, {
          flat: "",
          title: "Testes",
          rows: reports.value,
          "row-key": "id",
          columns: tableColumns,
          "rows-per-page-options": [10, 50, 100, 200, 0]
        }, {
          "body-cell-actions": _withCtx((props) => [
            _createVNode(_component_q_td, { props: props }, {
              default: _withCtx(() => [
                _createVNode(_component_q_btn, {
                  flat: "",
                  color: "primary",
                  label: "Visualizar",
                  to: `/teste/${props.row.id}/recomendacoes`
                }, null, 8, ["to"]),
                _createVNode(_component_q_btn, {
                  flat: "",
                  color: "primary",
                  label: "Editar",
                  to: `/teste/${props.row.id}/editar`
                }, null, 8, ["to"])
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          _: 1
        }, 8, ["rows"])
      ])
    ])
  ], 64))
}
}

})